/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedSearchSuggestions_searchBrowse$ref = any;
type SbSharedTitle_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespNullSearchResultsHeader_searchBrowse$ref: FragmentReference;
export type SbRespNullSearchResultsHeader_searchBrowse = {|
  +appliedFilters: ?$ReadOnlyArray<?{|
    +name: ?string
  |}>,
  +$fragmentRefs: SbSharedSearchSuggestions_searchBrowse$ref & SbSharedTitle_searchBrowse$ref,
  +$refType: SbRespNullSearchResultsHeader_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespNullSearchResultsHeader_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedSearchSuggestions_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedTitle_searchBrowse",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b36d6609badb07e5e349246736b91eba';
module.exports = node;
